var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.userInfo.vip || _vm.userInfo.vip.code == 0)?_c('el-tooltip',{attrs:{"placement":"top","effect":"dark","content":`${_vm.i18n.Pra.AI}${_vm.count}${_vm.i18n.Pra.second}`}},[_c('div',{staticClass:"vip-count"},[_c('span',{staticClass:"ai"},[_vm._v("AI")]),_c('span',[_vm._v("x"+_vm._s(_vm.count))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }